import React from "react";

import { Route, Redirect } from "react-router-dom";

import { authenticationService } from "../../services/authentication";

export function PrivateRoute({ children, ...rest }) {
  const currentUser = authenticationService.currentUserValue;

  return (
    <Route
      {...rest}
      render={({ location }) =>
        currentUser ? (
          children
        ) : (
          <Redirect
            to={{
              pathname: "/coming-soon",
              state: { from: location }
            }}
          />
        )
      }
    />
  );
}

export default PrivateRoute;
